import { createClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!url || !anonKey) {
  throw new Error(
    'VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY must be set in .env'
  );
}

export const supabase = createClient(url, anonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    // PKCE flow — Supabase v2 default for web is implicit (tokens in
    // URL fragment), which doesn't survive a Capacitor deep-link
    // redirect because Android intent URLs drop the fragment. PKCE
    // sends a `?code=` query param instead, which we then exchange
    // for a session via exchangeCodeForSession(). Works identically
    // on web and native; no regression for the SPA.
    flowType: 'pkce',
    detectSessionInUrl: true,
  },
});
